<template>
    <div class="flex flex-col bg-glassmorphic relative md:rounded-lg p-6 pb-5 list-container">
        <div class="flex mb-5">
            <i
                v-if="icon"
                :class="[`mr-2 icon icon-${icon}`]"
            ></i>
            <div
                v-if="skeleton"
                class="text-body-2"
            >
                <Skeleton
                    appearance="text"
                    class="min-w-[150px]"
                >
                </Skeleton>
            </div>
            <div
                v-else
                class="text-body-2"
            >
                {{ title }}
            </div>
            <div
                v-if="showNavButtonOnHover"
                class="nav-button-container ml-auto invisible md:visible"
            >
                <Btn
                    data-testid="dashboard-carousel-nav-left"
                    :variant="BtnVariant.TEXT"
                    color="rgba(0, 0, 0, 0.4)"
                    size="xs"
                    icon="chevron-circled-left"
                    compact
                    class="mr-1"
                    @click="previousCard"
                />
                <Btn
                    data-testid="dashboard-carousel-nav-right"
                    :variant="BtnVariant.TEXT"
                    color="rgba(0, 0, 0, 0.4)"
                    size="xs"
                    icon="chevron-circled-right"
                    compact
                    @click="nextCard"
                />
            </div>
        </div>

        <Carousel
            ref="dashboardCarousel"
            :vertical-padding="'4px'"
            :custom-gradient-color="'#FCFCFD'"
            show-nav-button-on-hover
        >
            <slot></slot>
        </Carousel>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Carousel from '@components/CarouselNew/Carousel.vue';
import { BtnVariant } from '@components/Btn';

export default defineComponent({
    name: 'DashboardCarousel',
    components: { Carousel },
    props: {
        /** title of the component */
        title: {
            type: String,
            default: null,
        },
        /** icon for the title */
        icon: {
            type: String,
            default: null,
        },
        /** show nav buttons only on hover */
        showNavButtonOnHover: {
            type: Boolean,
            default: false,
        },
        /** skeleton behaviour */
        skeleton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            BtnVariant,
        };
    },
    methods: {
        nextCard() {
            (this.$refs.dashboardCarousel as InstanceType<typeof Carousel>).nextSlides();
        },
        previousCard() {
            (this.$refs.dashboardCarousel as InstanceType<typeof Carousel>).previousSlides();
        },
    },
});
</script>

<style lang="scss" scoped>
.quest-card {
    transition: all 500ms;

    &:last-child {
        @apply mr-4;
    }
}
.list-container:not(:hover) .nav-button-container {
    opacity: 0;
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
}
.list-container:hover .nav-button-container {
    opacity: 1;
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
}
</style>
